import { z } from 'zod/v4';

export const SYSTEM_ADDRESS_BOOK_VARIABLES = {
    email: 'email',
    phone: 'phone',
    gdprConfirm: 'gdprConfirm',
    gdprTerms: 'gdprTerms',
} as const;

const DateObjSchema = z.object({
    date: z.string(),
    timezone_type: z.number(),
    timezone: z.string(),
});

export const AddressBookVariableSchema = z.object({
    address_book_id: z.number().optional(),
    id: z.union([z.number(), z.enum(['email', 'phone', 'gdprConfirm', 'gdprTerms'])]),
    variable_name: z.string(),
    variable_type: z.enum(['string', 'number', 'date']),
    status: z.number(),
});

export const AddressBookContract = z.object({
    id: z.number(),
    name: z.string(),
    status: z.number(),
    address_book_name: z.string(),
    active_emails_quantity: z.number(),
    active_phones_quantity: z.number(),
    inactive_emails_quantity: z.number(),
    excluded_phones_quantity: z.number(),
    exc_phones_quantity: z.number(),
    new_phones_quantity: z.number(),
    all_emails_quantity: z.number(),
    verified_emails_quantity: z.number(),
    email_verified: z.number(),
    rejected_emails_count: z.number(),
    rejected_email_count: z.number(),
    labels: z.array(z.string()),
    label_list: z.array(z.string()),
    segments: z.array(z.object({}).passthrough()),
    variables: z.array(AddressBookVariableSchema),
    activation_request_by_admin_quantity: z.number(),
    activation_request_by_email_quantity: z.number(),
    created_at: DateObjSchema,
    updated_at: DateObjSchema,
    date_created: DateObjSchema,
    date_modified: DateObjSchema,
});

export const AddressBookCollectionResponseSchema = z.object({
    data: z.array(AddressBookContract),
});

export type AddressBook = z.infer<typeof AddressBookContract>;
export type AddressBookVariable = z.infer<typeof AddressBookVariableSchema>;
